"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isOnlyActiveSalesforceOwner = exports.isActiveHubSpotOwner = void 0;

var _get = _interopRequireDefault(require("transmute/get"));

var isActiveHubSpotOwner = function isActiveHubSpotOwner(owner) {
  return Boolean((0, _get.default)('activeUserId', owner));
};

exports.isActiveHubSpotOwner = isActiveHubSpotOwner;

var isOnlyActiveSalesforceOwner = function isOnlyActiveSalesforceOwner(owner) {
  return Boolean((0, _get.default)('activeSalesforceId', owner)) && !isActiveHubSpotOwner(owner);
};

exports.isOnlyActiveSalesforceOwner = isOnlyActiveSalesforceOwner;